module.exports = __webpack_public_path__ + "static/media/si.b8b8df2f.svg";